import {
  normalizeCreatedExternalService,
  normalizeExternalService,
  normalizeExternalServices,
  normalizeExternalServiceToken,
  normalizeIssuedExternalServiceToken,
} from "@/lib/externalServices/normalize";
import type {
  CreatedExternalService,
  ExternalServiceCreatePayload,
  ExternalServiceDto,
  ExternalServiceTokenDto,
  ExternalServiceUpdatePayload,
  IssuedExternalServiceToken,
} from "@/types/externalService";
import { apiRequest } from "./client";

function requireValue<T>(value: T | null, message: string): T {
  if (value == null) throw new Error(message);
  return value;
}

export function fetchExternalServices(): Promise<ExternalServiceDto[]> {
  return apiRequest<unknown>("/api/v1/external-services").then(
    normalizeExternalServices,
  );
}

export function fetchExternalService(
  serviceId: number,
): Promise<ExternalServiceDto> {
  return apiRequest<unknown>(`/api/v1/external-services/${serviceId}`).then(
    (body) =>
      requireValue(
        normalizeExternalService(body),
        "Некорректный ответ внешнего сервиса",
      ),
  );
}

export function createExternalService(
  payload: ExternalServiceCreatePayload,
): Promise<CreatedExternalService> {
  return apiRequest<unknown>("/api/v1/external-services", {
    method: "POST",
    body: JSON.stringify(payload),
  }).then((body) =>
    requireValue(
      normalizeCreatedExternalService(body),
      "Некорректный ответ создания внешнего сервиса",
    ),
  );
}

export function updateExternalService(
  serviceId: number,
  payload: ExternalServiceUpdatePayload,
): Promise<ExternalServiceDto> {
  return apiRequest<unknown>(`/api/v1/external-services/${serviceId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  }).then((body) =>
    requireValue(
      normalizeExternalService(body),
      "Некорректный ответ обновления внешнего сервиса",
    ),
  );
}

export function deleteExternalService(serviceId: number): Promise<void> {
  return apiRequest<void>(`/api/v1/external-services/${serviceId}`, {
    method: "DELETE",
  });
}

export function issueExternalServiceToken(
  serviceId: number,
  name: string | null,
): Promise<IssuedExternalServiceToken> {
  return apiRequest<unknown>(
    `/api/v1/external-services/${serviceId}/tokens`,
    {
      method: "POST",
      body: JSON.stringify({ name }),
    },
  ).then((body) =>
    requireValue(
      normalizeIssuedExternalServiceToken(body),
      "Некорректный ответ выпуска токена",
    ),
  );
}

export function revokeExternalServiceToken(
  serviceId: number,
  tokenId: number,
): Promise<ExternalServiceTokenDto> {
  return apiRequest<unknown>(
    `/api/v1/external-services/${serviceId}/tokens/${tokenId}`,
    { method: "DELETE" },
  ).then((body) =>
    requireValue(
      normalizeExternalServiceToken(body),
      "Некорректный ответ отзыва токена",
    ),
  );
}
